module.exports = __webpack_public_path__ + "static/img/bg27.418dd879.png";